/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MessengerMemberType = {
    Support: 'SUPPORT',
    Customer: 'CUSTOMER',
    Carrier: 'CARRIER',
    User: 'USER',
    Fr8Bot: 'FR8BOT'
} as const;
export type MessengerMemberType = typeof MessengerMemberType[keyof typeof MessengerMemberType];

